export class MKGooglePAL {
    private nonceManager: any;

    constructor() {
        this.loadPAL();
    }

    private async loadPAL(): Promise<void> {
        return new Promise((resolve, reject) => {

            const script = document.createElement("script");
            script.src = "https://imasdk.googleapis.com/pal/sdkloader/pal.js";
            script.async = true;
            script.onload = () => {
                console.log(" Google PAL SDK loaded.");
                resolve();
            };
            script.onerror = () => reject(new Error("Failed to load Google PAL SDK"));

            document.head.appendChild(script);
        });
    }

    public async generateNonce(): Promise<string> {
        await this.loadPAL();

        if (!(window as any).goog?.pal) {
            console.error("PAL SDK not loaded.");
            return '';
        }

        const nonceLoader = new (window as any).goog.pal.NonceLoader();
        const request = new (window as any).goog.pal.NonceRequest();

        request.adWillAutoPlay = true;
        request.adWillPlayMuted = false;
        request.continuousPlayback = false;
        request.descriptionUrl = "https://example.com";
        request.iconsSupported = true;
        request.playerType = "Sample Player Type";
        request.playerVersion = "1.0";
        request.ppid = "Sample PPID";
        request.sessionId = "Sample SID";
        request.supportedApiFrameworks = "2,7,9"; // VPAID 2.0, OMID 1.0, SIMID 1.1
        request.url = "https://developers.google.com/ad-manager/pal/html5";
        request.videoHeight = 480;
        request.videoWidth = 640;

        try {
            this.nonceManager = await nonceLoader.loadNonceManager(request);
            console.log("Nonce generated: " + this.nonceManager.getNonce());
            const nonce : string = this.nonceManager.getNonce();
            return nonce;
        } catch (error) {
            console.error("Error generating nonce:", error);
            return ''
        }
    }
}
